import { render, staticRenderFns } from "./scan-with-file.vue?vue&type=template&id=04d76850"
import script from "./scan-with-file.vue?vue&type=script&lang=js"
export * from "./scan-with-file.vue?vue&type=script&lang=js"
import style0 from "./scan-with-file.vue?vue&type=style&index=0&id=04d76850&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports